import { Link } from "react-router-dom";
import { ShieldCheck, Target, Layers, Users } from "lucide-react";
import { Layout } from "@/components/Layout";
import { Seo } from "@/components/Seo";
import { useSettings } from "@/context/SettingsContext";

export default function About() {
  const { settings } = useSettings();
  return (
    <Layout>
      <Seo title="About Mashiniya — New & Used Machines and Spare Parts | Indra Sphere" description="Mashiniya by Indra Sphere is a specialized platform for discovering new machines, used machines and machine spare parts and connecting directly with sellers across India." canonical={window.location.origin + "/about"} />
      <div className="bg-slate-900 py-16 text-white">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-[hsl(var(--brand))]">Mashiniya by {settings.parent_company}</p>
          <h1 className="mt-3 font-display text-4xl font-extrabold sm:text-5xl">About Mashiniya</h1>
          <p className="mt-4 max-w-2xl text-lg text-slate-300">
            Mashiniya is a specialized platform for discovering and connecting buyers and sellers of used, old and second-hand machines.
          </p>
        </div>
      </div>

      <div className="mx-auto max-w-4xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid gap-6 sm:grid-cols-2">
          {[
            { icon: Target, t: "Our Focus", d: "A platform dedicated specifically to used and pre-owned machinery — not a generic classifieds site." },
            { icon: Layers, t: "Wide Coverage", d: "Construction, agricultural, drilling, industrial, earthmoving and other machinery categories." },
            { icon: Users, t: "Direct Connection", d: "Buyers connect directly with verified sellers through WhatsApp — no middlemen, no fees for buyers." },
            { icon: ShieldCheck, t: "Trust & Transparency", d: "Detailed photos, specifications, descriptions and videos so buyers can make informed decisions." },
          ].map((c) => (
            <div key={c.t} className="rounded-2xl border border-slate-200 bg-white p-6">
              <c.icon className="mb-3 brand-accent" size={28} />
              <h3 className="font-display text-lg font-bold text-slate-900">{c.t}</h3>
              <p className="mt-1.5 text-slate-600">{c.d}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 rounded-2xl border border-slate-200 bg-white p-8">
          <h2 className="font-display text-2xl font-bold text-slate-900">Parent Company</h2>
          <p className="mt-2 text-slate-600">{settings.parent_company}</p>
          <p className="mt-1 text-slate-600">{settings.address}</p>
          <div className="mt-4 flex flex-col gap-1 text-slate-600">
            <a href={`tel:${settings.phone1}`}>{settings.phone1}</a>
            <a href={`tel:${settings.phone2}`}>{settings.phone2}</a>
            <a href={`mailto:${settings.email}`} className="brand-accent font-semibold">{settings.email}</a>
          </div>
          <Link to="/used-machines" className="mt-6 inline-flex rounded-full bg-brand px-6 py-3 text-sm font-bold text-white">Browse Machines</Link>
        </div>
      </div>
    </Layout>
  );
}
